export enum ComplaineeType{
    Repair_Centre_complains_that = 1,
    Customer_complains_that = 2
}